import { defineMessages } from 'react-intl';
import globalIntl from 'globalIntl'; // eslint-disable-line import/no-unresolved

const m = defineMessages({
  notifications: {
    id: 'notifications',
    defaultMessage: 'Notifications',
  },
  markAsRead: {
    id: 'markAsRead',
    defaultMessage: 'Mark as read',
  },
  noNotify: {
    id: 'noNotify',
    defaultMessage: "You don't have any notifications yet.",
  },
  noNotifyInfo: {
    id: 'noNotifyInfo',
    defaultMessage: 'Notifications about any news and updates will be here.',
  },
  notify_newEvent: {
    id: 'notify_newEvent',
    defaultMessage: 'invited you to the event',
  },
  notify_newActor: {
    id: 'notify_newActor',
    defaultMessage: 'invited you to the actor',
  },
  notify_comment: {
    id: 'notify_comment',
    defaultMessage: 'commented event',
  },
  notify_reject: {
    id: 'notify_reject',
    defaultMessage: 'rejected event',
  },
  notify_rating: {
    id: 'notify_rating',
    defaultMessage: 'rated event',
  },
});

export default { ...globalIntl, ...m };
